import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import imageNotFound from "../../common/assets/images/imageNotFound.png"
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Banner = () => {
  const location = useLocation();
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);
  const queryParams = new URLSearchParams(location.search);
  let photoUrls=location?.state?.photoUrls || JSON.parse(queryParams.get('photoUrls')) || []

  useEffect(() => {
    setNav1(sliderRef1);
    setNav2(sliderRef2);
  }, []);

  const settings = {
    nextArrow: null,
    prevArrow: null,
  };

  return photoUrls?.length > 0 ? (
    <div className='slider-container product_page_slider_arrow_none'>
      <Slider
        asNavFor={nav2}
        ref={(slider) => (sliderRef1 = slider)}
        {...settings}
      >
        {photoUrls?.map((url) => (
          <div key={url}>
            <div className='flex items-center justify-center p-4 h-[400px] mt-2.5'>
              <img src={url} className='w-[800px] object-cover' alt='' />
            </div>
          </div>
        ))}
      </Slider>
      <Slider
        asNavFor={nav1}
        ref={(slider) => (sliderRef2 = slider)}
        slidesToShow={3}
        swipeToSlide={true}
        focusOnSelect={true}
        className='productPageSlider'
      >
        {photoUrls?.map((url) => (
          <div key={url}>
            <img
              src={url}
              alt=''
              className='w-[252px] h-[168px] object-cover mr-2.5'
            />
          </div>
        ))}
      </Slider>
    </div>
  ) : (
    <div className='flex items-center justify-center p-4 h-[400px] mt-2.5'>
    <img src={imageNotFound} className='w-[800px] h-[100%] object-cover' alt='' />
  </div>
  );
};

export default Banner;
